export default __webpack_public_path__ + "locales/ro/WebPlugins.json?hash=cabbf5be3bd7ae97cae68fa947a4bf7b";